<template>
  <b-container
    fluid
    class="w-100 m-0 py-0 pl-3 pr-0"
  >
    <b-row>
      <b-button
        v-b-tooltip.hover.bottom="'Add Feature'"
        size="sm"
        variant="outline-success"
        class="m-0 p-0 btn-add-feature"
        @mouseover="onHover('ReportViewer/Studies/addFeature')"
        @mouseleave="onLeave"
        @click="addFeature"
      >
        <b-icon
          aria-label="Add Value"
          icon="plus-square-fill"
          class="m-0 p-0"
        />
      </b-button>
    </b-row>
    <b-row
      v-for="(feature, index) in featuresLocalList"
      :key="index"
      class="mb-2"
    >
      <b-container
        fluid
        class="w-100 mx-2 mt-2 mb-0 p-2 feature-container"
      >
        <b-row
          class="w-100 m-0 p-0"
          align-h="between"
        >
          <b-col md="auto">
            Feature {{ index + 1 }}:
          </b-col>
          <b-col md="auto">
            <b-button
              v-b-tooltip.hover.bottom="'Remove Feature'"
              size="sm"
              variant="outline-danger"
              class="m-0 p-0 btn-add-feature"
              @mouseover="onHover('ReportViewer/Studies/removeFeature')"
              @mouseleave="onLeave"
              @click="removeFeature(index)"
            >
              <b-icon
                aria-label="Remove Value"
                icon="trash-fill"
                class="m-0 p-0"
              />
            </b-button>
          </b-col>
        </b-row>
        <b-row class="w-100 m-0 p-0">
          <b-col md="auto">
            <b-dropdown
              split
              split-variant="outline-primary"
              variant="primary"
              :text="feature.type"
              class="mt-1 combobox-config shadow-sm"
              size="sm"
            >
              <b-dropdown-item
                v-for="optionType in typeFeatures"
                :key="optionType.value"
                :value="optionType.value"
                @click="onChangeType(feature, optionType)"
              >
                {{ optionType.text }}
              </b-dropdown-item>
            </b-dropdown>
          </b-col>
          <b-col md="auto">
            <b-dropdown
              split
              split-variant="outline-primary"
              variant="primary"
              :text="feature.validation"
              class="mt-1 combobox-config shadow-sm"
              size="sm"
            >
              <b-dropdown-item
                v-for="optionValid in validationFeatures"
                :key="optionValid.value"
                :value="optionValid.value"
                @click="onChangeValidation(feature, optionValid)"
              >
                {{ optionValid.text }}
              </b-dropdown-item>
            </b-dropdown>
          </b-col>
        </b-row>
        <b-row class="w-100 m-0 px-0 pb-0 pt-1">
          <b-col md="auto">
            <b-form-input
              v-model="feature.hidden.value1"
              :state="isNumber(feature.hidden.value1)"
              aria-describedby="input-live-help input-live-feedback"
              :placeholder="feature.validation === 'Within range' ? 'Min Val' : 'Value'"
              size="sm"
              class="input-value-feature"
              @change="setConfigReportModifiedReportViewer()"
            />
            <b-form-invalid-feedback class="input-live-feedback">
              Enter a valid number
            </b-form-invalid-feedback>
          </b-col>
          <b-col
            v-if="feature.validation === 'Within range'"
            md="auto"
          >
            <b-form-input
              v-model="feature.hidden.value2"
              :state="isNumber(feature.hidden.value2) && feature.hidden.value2 !== feature.hidden.value1"
              aria-describedby="input-live-help input-live-feedback"
              :placeholder="'Max Val'"
              size="sm"
              class="input-value-feature"
              @change="setConfigReportModifiedReportViewer()"
            />
            <b-form-invalid-feedback class="input-live-feedback">
              Enter a valid number different than the min value
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </b-container>
    </b-row>
    <b-row
      align-v="center"
      class="ml-2"
    >
      <b-button
        v-b-tooltip.hover.top="'Open the interactive window Area of Interest'"
        size="sm"
        variant="info"
        @click="openAoIConfig"
      >
        <b-icon
          icon="gear-fill"
          aria-hidden="true"
        /> Configure AoI
      </b-button>
    </b-row>
  </b-container>
</template>

<script>
import { hiddenConfCtrller } from '@/assets/classes/configuration.js'
import { ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'
import { mapGetters, mapActions } from 'vuex'

const mapFeatures = {
    mean: 'Mean',
    max: 'Max',
    min: 'Min',
    STD: 'STD',
    ΔX: 'ΔX', // This was missed
    ΔY:'ΔY' // This was missed

}
const mapValidations = {
    greater: 'Greater than',
    less: 'Less than',
    range: 'Within range',
}

export default {
    name: 'FeatureCheck',
    props: {
        sectionconfig: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            elementsConfig: [],
            typeFeatures: [
                { text: 'Mean', value: 'mean' },
                { text: 'Max', value: 'max' },
                { text: 'Min', value: 'min' },
                { text: 'STD', value: 'STD' },
                { text: 'ΔX', value: 'ΔX' }, //ΔX
                { text: 'ΔY', value: 'ΔY' },//ΔY
            ],
            validationFeatures: [
                { text: 'Greater than', value: 'greater' },
                { text: 'Less than', value: 'less' },
                { text: 'Within range', value: 'range' },
            ],
            featuresLocalList: [],
            featuresCtller: new hiddenConfCtrller(`${ConfigName.BaseFeatureCheck}.features`, []),
        }
    },
    computed: mapGetters(['getCurrentReportViewer']),
    watch: {
        sectionconfig() {
            this.configureStudy()
        }
    },
    created() {
        this.elementsConfig = [
            this.featuresCtller,
        ]
    },
    mounted() {
        this.configureStudy()
    },
    methods: {
        ...mapActions([
            'setGraphsConfWindow',
            'setConfigReportModifiedReportViewer',
            'setContextOnHover'
        ]),
        addFeature() {
            this.setConfigReportModifiedReportViewer()
            const newValueHidden = {
                type: 'mean',
                validation: 'greater',
                value1: '0',
                value2: '1',
            }
            this.featuresCtller.value.push(newValueHidden)
            this.featuresLocalList.push({
                type: 'Mean',
                validation: 'Greater than',
                hidden: newValueHidden
            })
        },
        removeFeature(index) {
            this.setConfigReportModifiedReportViewer()
            this.featuresLocalList.splice(index, 1)
            this.featuresCtller.value.splice(index, 1)
        },
        configureStudy() {
            this.featuresLocalList = []
            this.elementsConfig.forEach(conf => conf.configCategory = this.sectionconfig)
            this.elementsConfig.forEach(conf => conf.setParent(this))
            for (const feature of this.featuresCtller.value) {
                this.featuresLocalList.push({
                    type: mapFeatures[feature.type],
                    validation: mapValidations[feature.validation],
                    hidden: feature
                })
            }
        },
        openAoIConfig() {


            this.setGraphsConfWindow([{ //Add the selected configuration to the Interfactive Configuration Pop-up
                type: 'AREA_INTEREST_VALUES',
                study: this.sectionconfig
            }])
        },
        isNumber(value) {
            return value !== '' && !isNaN(value)
        },
        onHover(route) {
            this.setContextOnHover(route)
        },
        onLeave() {
            this.setContextOnHover(null)
        },
        onChangeType(feature, optionType) {
            feature.type = optionType.text;
            feature.hidden.type = optionType.value;
            this.setConfigReportModifiedReportViewer()
        },
        onChangeValidation(feature, optionValid) {
            feature.validation = optionValid.text;
            feature.hidden.validation = optionValid.value;
            this.setConfigReportModifiedReportViewer()
        }
    }
}
</script>

<style lang="scss" scoped>
.btn-add-feature {
    height: 1.5rem;
}

.input-value-feature {
    width: 6rem;
}

.input-live-feedback {
    font-size: 0.8rem;
    width: 6rem;
}

.feature-container {
    background-color: #CEFFCE;
    border: 1.5px solid #12B700;
    border-radius: 10px;
}
</style>